// import React, { useRef } from 'react';
// import ReactHtmlTableToExcel from 'react-html-table-to-excel';
// import { useSelector } from 'react-redux';
// import ReactToPrint, { useReactToPrint } from 'react-to-print';
// import logo from '../../../../assets/images/logo.jpeg';
// import BusinessInfo from '../../../Shared/BusinessInfo';

// // import { ComponentToPrint } from './ComponentToPrint';


// const ViewInvoice = ({ salesModal, setSalesModal }) => {
//     const userAc = useSelector((state) => state.user.user);
//     const componentRef = useRef();
//     const { discount, dueAmount, grandTotal, payment, products, salesDate, salesInvoice, salesCustomer, totalAmount, salesAddress } = salesModal;

//     console.log(salesModal);

//     const closeModal = () => {
//         setSalesModal(null);
//     }



//     const generatePrint = useReactToPrint({
//         content: () => componentRef.current,
//         documentTitle: `Sales Inovice No-${salesInvoice}`,

//     })

//     const totalCost = products.reduce((total, currentValue) => total + parseInt(currentValue?.cost), 0);

//     return (
//         <>
//             <div className="z-50">
//                 <input type="checkbox" id="view-modal" class="modal-toggle" />
//                 <div class="modal mt-12">
//                     <div class="modal-box max-w-none lg:w-8/12 lg:ml-60 relative">
//                         <div className='text-right'>
//                             <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
//                         </div>
//                         <div ref={componentRef}>
//                             <div className='flex justify-center items-center mt-8'>
//                                 <div>
//                                     <img src={BusinessInfo.img} className="w-20 lg:w-44 lg:mr-20 lg:mb-4" alt="" />
//                                 </div>
//                                 <div className='lg:mr-40'>
//                                     <h1 className='text-xl lg:text-4xl text-textPrimary text-center'>{BusinessInfo.fullName}</h1>
//                                   {/* <h1 className='text-sm lg:text-xl text-textPrimary text-center'>{BusinessInfo.dealer}</h1> */}
//                                     <h1 className='text-xs text-textPrimary text-center'>{BusinessInfo.address}</h1>
//                                     <h1 className='text-xs lg:text-xl text-textPrimary text-center'>{BusinessInfo.mobile}</h1>
//                                 </div>
//                             </div>
//                             <div class="flex items-center justify-between">
//                                 <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
//                                 <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
//                             </div>
//                             <div class="flex items-center justify-between">
//                                 <hr class="border-b border-gray-300 w-full my-px" />
//                                 <hr class="border-b border-gray-300 w-full my-px" />
//                             </div>
//                             <label for="view-modal" onClick={closeModal} class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
//                             <h3 class="text-2xl uppercase text-center font-bold mt-8">Sales Invoice</h3>
//                             <div className='text-left ml-20 text-xs'>
//                                 <p><span style={{ marginRight: '31px' }} className='font-bold'>Invoice No:</span>{salesInvoice}</p>
//                                 <p><span style={{ marginRight: '71px' }} className='font-bold'>Date:</span>  {salesDate}</p>
//                                 <p><span className='font-bold mr-8'>Customer:</span>{salesCustomer}</p>
//                                 <p><span className='font-bold mr-12'>Address:</span>{salesAddress}</p>
//                             </div>
//                             <div className='overflow-auto'>
//                                 <table class="table w-1/2 mt-8 mx-auto text-xs">
//                                     <thead className='text-center'>
//                                         <tr>
//                                             <th className='bg-primary text-white normal-case'>SL#</th>
//                                             <th className='bg-primary text-white normal-case'>Product Code</th>
//                                             <th className='bg-primary text-white normal-case'>Product Name</th>
//                                             <th className='bg-primary text-white normal-case'>Quantity</th>
//                                             <th className='bg-primary text-white normal-case'>Rate</th>
//                                             <th className='bg-primary text-white normal-case'>Total</th>
//                                             {userAc?.showCostInInvoice && <th className='bg-primary text-white normal-case'>Cost</th>}
//                                         </tr>
//                                     </thead>
//                                     <tbody className='text-center'>
//                                         {
//                                             products.map((product, index) => <tr className=''>
//                                                 <td>{index + 1}</td>
//                                                 <td>{product.code}</td>
//                                                 <td>{product.name}</td>
//                                                 <td>{product.quantity}</td>
//                                                 <td>{product.rate}</td>
//                                                 <td >{product.total}</td>
//                                                {userAc?.showCostInInvoice&& <td >{product.cost}</td>}
//                                             </tr>)
//                                         }

//                                     </tbody>
//                                     <tbody className='text-center bg-white'>
//                                         <tr className='border-t-2 border-black'>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td ></td>
//                                             <td >Total</td>
//                                             <td className='font-bold'>{totalAmount}</td>
//                                             {userAc?.showCostInInvoice && <td className='font-bold'>{totalCost}</td>}
//                                         </tr>
//                                         <tr className=''>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td>Discount</td>
//                                             <td className='font-bold'>{discount}</td>
//                                         </tr>
//                                         <tr className=''>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td className='font-bold'>Grand Amount</td>
//                                             {userAc?.showCostInInvoice && <td className='font-bold'>{grandTotal}</td>}
//                                         </tr>
//                                         <tr className=''>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td>Payment</td>
//                                             <td className='font-bold'>{payment}</td>
//                                         </tr>
//                                         <tr className=''>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td></td>
//                                             <td>Total Due</td>
//                                             <td className='font-bold'>{dueAmount}</td>
//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                             <div className='flex justify-between mt-40'>
//                                 <h3 className='border-t-2 border-gray-400 py-2 inline-block ml-40 font-bold text-sm'>Authorized Sign</h3>
//                                 <h3 className='border-t-2 border-gray-400 py-2 inline-block mr-40 font-bold text-sm'>Customer Sign</h3>
//                             </div>

//                             {/* <div>
//                                 <h1 className='text-center mt-40 text-sm'>(For Any Kind of Shop, Showroom and Business Software Please Contact: 01310-751276)</h1>
//                                 <h1 className='text-center text-sm'>(যেকোন ধরনের দোকান, শোরুম ও ব্যবসায়ের সফটওয়্যারের জন্য যোগাযোগ করুন: ০১৩১০-৭৫১২৭৬)</h1>
//                             </div> */}

//                         </div>



//                     </div>
//                 </div >
//             </div >
//         </>
//     );
// };

// export default ViewInvoice;

import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import BusinessInfo from '../../../Shared/BusinessInfo';

const ViewInvoice = ({ salesModal, setSalesModal }) => {
  const userAc = useSelector((state) => state.user.user);
  const componentRef = useRef();
  const {
    discount,
    dueAmount,
    grandTotal,
    payment,
    products,
    salesDate,
    salesInvoice,
    salesCustomer,
    totalAmount,
    salesAddress,
  } = salesModal;

  const closeModal = () => {
    setSalesModal(null);
  };

  const generatePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Sales Invoice No-${salesInvoice}`,
    pageStyle: `
      @page {
        size: auto;
        margin: 0;
      }
      body {
        width: 3in;
        font-size: 9px;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .invoice-product {
        margin-bottom: 4px;
      }
      .invoice-product span {
        display: inline-block;
        word-break: break-word;
      }
      .invoice-footer span {
        display: inline-block;
        width: 50%;
      }
    `,
  });



 const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const bangladeshTime = now.toLocaleString("en-US", {
        timeZone: "Asia/Dhaka",
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      setTime(bangladeshTime);
    };

    updateTime(); // set initial time
    const interval = setInterval(updateTime, 1000); // update every second

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <div className="z-50">
      <input type="checkbox" id="view-modal" className="modal-toggle" />
      <div className="modal mt-12">
        <div className="modal-box max-w-none w-[380px] relative">
          <div className="text-right">
            <button
              className="btn btn-success btn-xs ml-2 text-white"
              onClick={generatePrint}
            >
              Print
            </button>
          </div>

          <div
            ref={componentRef}
            className="p-1 text-[9px] w-[3in] overflow-hidden"
          >
            {/* Header */}
            <div className="text-center">
              <img
                src={BusinessInfo.img}
                className="w-16 mx-auto mb-1"
                alt="Logo"
              />
              <h1 className="text-sm font-bold">{BusinessInfo.fullName}</h1>
              <p className="text-[10px]">{BusinessInfo.dealer}</p>
              <p className="text-[9px]">{BusinessInfo.address}</p>
              <p className="text-[9px]">{BusinessInfo.mobile}</p>
            </div>

            <h3 className="text-xs uppercase text-center font-bold mt-1">
              Sales Invoice
            </h3>

            {/* Invoice info */}
            <div className="text-left text-[9px] mt-1">
              <p><span className="font-bold">Invoice:</span> {salesInvoice}</p>
              <p><span className="font-bold">Date:</span> {salesDate}</p>
              <p><span className="font-bold">Printing Time:</span> {time}</p>
              <p><span className="font-bold">Customer:</span> {salesCustomer}</p>
              <p><span className="font-bold">Address:</span> {salesAddress}</p>
            </div>

            {/* Products (single-column layout) */}
            <div className="mt-1">
              {products.map((product, index) => (
                <div key={index} className="invoice-product">
                  <div>
                    <strong>{index + 1}. {product.name}</strong>
                  </div>
                  <div>
                    <span>Code: {product.code}</span> |{' '}
                    <span>Qty: {product.quantity}</span> |{' '}
                    {/* changes rate to sell */}
                    <span>Rate: {product.sell}</span> |{' '} 
                    <span>Total: {product.total}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Totals */}
            <div className="invoice-footer mt-2 text-[11px]">
              <div><span>Total:</span> <span>{totalAmount}</span></div>
              <div><span>Discount:</span> <span>{discount}</span></div>
              <div className='font-bold'><span>Grand Total:</span> <span>{grandTotal}</span></div>
              <div><span>Payment:</span> <span>{payment}</span></div>
              <div><span>Due:</span> <span>{dueAmount}</span></div>
            </div>

            {/* Signatures */}
            <div className="flex justify-between text-[9px] mt-2">
              <p className="border-t w-24 text-center">Authorized</p>
              <p className="border-t w-24 text-center">Customer</p>
            </div>
          </div>

          <label
            htmlFor="view-modal"
            onClick={closeModal}
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoice;
